var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("运营管理")]),
              _c("el-breadcrumb-item", [_vm._v("限购模版设置")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "限购规则：", prop: "title" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              size: "small",
                              placeholder: "请输入限购规则",
                            },
                            model: {
                              value: _vm.listParams.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.listParams, "title", $$v)
                              },
                              expression: "listParams.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "限购规则" },
              }),
              _c("el-table-column", {
                attrs: { prop: "priority", align: "center", label: "使用状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.priority > 0
                          ? _c("span", [_vm._v(" 使用中 ")])
                          : _c("span", [_vm._v(" 未使用 ")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "associatedGoodCount",
                  align: "center",
                  label: "关联商品数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  align: "center",
                  label: "内容描述",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.description
                          ? _c("div", [
                              scope.row.description.length > 10
                                ? _c(
                                    "div",
                                    [
                                      _c("el-popover", {
                                        ref: "popover1",
                                        attrs: {
                                          placement: "top-start",
                                          width: "200",
                                          trigger: "hover",
                                          content: scope.row.description,
                                        },
                                      }),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "popover",
                                              rawName: "v-popover:popover1",
                                              arg: "popover1",
                                            },
                                          ],
                                          staticStyle: { color: "#606266" },
                                          attrs: { type: "text" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatLimitLength")(
                                                  scope.row.description
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.row.description) + " "
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.detailItem(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editItem(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "规则名称 ：", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入规则名称" },
                        model: {
                          value: _vm.itemParams.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "title", $$v)
                          },
                          expression: "itemParams.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "限购类型 ：", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择限购类型",
                          },
                          model: {
                            value: _vm.itemParams.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "type", $$v)
                            },
                            expression: "itemParams.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 1, label: "数量限购" },
                          }),
                          _c("el-option", {
                            attrs: { value: 2, label: "规则限购" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "限购的值：", prop: "value" } },
                    [
                      _vm.itemParams.type === 1
                        ? _c("el-input-number", {
                            attrs: {
                              size: "small",
                              min: 1,
                              max: 99,
                              label: "描述文字",
                            },
                            model: {
                              value: _vm.itemParams.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.itemParams, "value", $$v)
                              },
                              expression: "itemParams.value",
                            },
                          })
                        : _c("el-input-number", {
                            attrs: {
                              size: "small",
                              min: 1,
                              max: 999,
                              label: "描述文字",
                            },
                            model: {
                              value: _vm.itemParams.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.itemParams, "value", $$v)
                              },
                              expression: "itemParams.value",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "优先级：", prop: "priority" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          size: "small",
                          min: 1,
                          max: 100,
                          label: "描述文字",
                        },
                        model: {
                          value: _vm.itemParams.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "priority", $$v)
                          },
                          expression: "itemParams.priority",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内容描述：", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入内容描述",
                        },
                        model: {
                          value: _vm.itemParams.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "description", $$v)
                          },
                          expression: "itemParams.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveRestrictionRule("dialogForm")
                            },
                          },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: "限购规则详情",
            visible: _vm.detailVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.detailParams, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "规则名称 ：", prop: "title" } },
                [_c("span", [_vm._v(_vm._s(_vm.detailParams.title))])]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购类型 ：", prop: "type" } },
                [
                  _vm.detailParams.type === 1
                    ? _c("span", [_vm._v("数量限购")])
                    : _vm._e(),
                  _vm.detailParams.type === 2
                    ? _c("span", [_vm._v("规则限购")])
                    : _vm._e(),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "限购的值：", prop: "value" } },
                [_c("span", [_vm._v(_vm._s(_vm.detailParams.value))])]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "优先级：", prop: "priority" } },
                [_c("span", [_vm._v(_vm._s(_vm.detailParams.priority))])]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "内容描述：", prop: "description" } },
                [_c("span", [_vm._v(_vm._s(_vm.detailParams.description))])]
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.detailVisible = false
                        },
                      },
                    },
                    [_vm._v(" 返 回 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }